export const BTabsKey = Symbol('BTabsKey');
